import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class SharedHelpersService {

  constructor(
    private translate: TranslateService,
    private http: HttpClient,
    private messageService: MessageService,
  ) { }


/**
 * Method to Download a excelfile.
 * 
 */
  public downloadFile(url: any) {
    try {

      this.http.get(url, { responseType: 'blob' }).subscribe(
        (response) => {
          const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

          // Extract the file name from the URL
          const urlSegments = url.split('/');
          const fileName = urlSegments[urlSegments.length - 1];

          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = fileName; // Use the extracted file name here
          link.click();
          window.URL.revokeObjectURL(downloadUrl);
        },
        (error) => {
          // Handle error from the HTTP request
          console.log(error);
          this.messageService.add({
            severity: 'error',
            summary: '',
            detail: this.translate.instant('transversales.requestMessages.DownloadError'),
          });
        }
      );
    } catch (error) {
      // Handle any other errors
      console.log(error);
      this.messageService.add({
        severity: 'error',
        summary: '',
        detail: this.translate.instant('transversales.requestMessages.DownloadError'),
      });
    }
  }


/**
 * Capitalizes the first letter of the given text.
 *
 * @param text - The string to be transformed.
 * @returns The transformed string with the first letter capitalized.
 */
 public capitalizeFirstLetter(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
 }

  /**
   * Converts a Base64-encoded string to a Blob object.
   *
   * @param base64Data - The Base64-encoded string, optionally prefixed with a data URI scheme (e.g., "data:;base64,").
   * @param contentType - The MIME type of the resulting Blob. Defaults to an empty string.
   * @param sliceSize - The size of the byte slices used to process the Base64 string. Defaults to 512.
   * @returns A Blob object representing the decoded binary data.
   */
  base64ToBlob(base64Data: string, contentType = '', sliceSize = 512): Blob {
    let base64 = base64Data.split(',')[1];
    let byteCharacters = atob(base64);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = Array.from(slice, char => char.charCodeAt(0));
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: contentType });
  }

  /**
   * Validates a file against allowed extensions and a maximum file size.
   * If validation fails, shows an error toast and returns false.
   *
   * @param file - The File object to validate.
   * @param allowedExtensions - Array of allowed extensions (e.g. ['.pdf', '.jpg']).
   * @param maxFileSize - Maximum file size in bytes (default: 1 MB).
   * @returns true if the file is valid, false otherwise.
   */
  validateFile(file: File, allowedExtensions: string[], maxFileSize: number = 1 * 1024 * 1024): boolean {
    const fileExtension = '.' + (file.name.split('.').pop()?.toLowerCase() || '');

    if (!allowedExtensions.includes(fileExtension)) {
      this.messageService.add({
        severity: 'error',
        summary: '',
        detail: this.translate.instant('transversales.requestMessages.invalidFileFormat'),
      });
      return false;
    }

    if (file.size > maxFileSize) {
      this.messageService.add({
        severity: 'error',
        summary: '',
        detail: this.translate.instant('transversales.requestMessages.uploadFileWeight'),
      });
      return false;
    }

    return true;
  }

}
